import { useCallback } from 'react';
/**
 * Merges multiple refs objects or functions into one ref callback
 *
 * Inspired by Mantine:
 * https://github.com/mantinedev/mantine/blob/master/packages/@mantine/hooks/src/use-merged-ref/use-merged-ref.ts
 */
export function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (typeof ref === 'object' && ref !== null && 'current' in ref) {
        ref.current = value;
    }
}
export function mergeRefs(...refs) {
    return (node) => {
        refs.forEach(ref => assignRef(ref, node));
    };
}
export function useMergedRef(...refs) {
    return useCallback(mergeRefs(...refs), refs);
}
//# sourceMappingURL=useMergedRef.js.map